// src/modules/jobPostings/config/requisitionConfig.js
export const REQUISITION_CONFIG = {
  DEFAULT_DURATION_DAYS: 20,
  SUCCESS_REDIRECT: "/job-posting",
};
